import axios from "axios";

export const URL = "https://cut-backend.appssquare.com";

const getLang = () => {
  const roles = localStorage.getItem("lang");
  return roles;
};
const instance = axios.create({
  baseURL: `${URL}/api/`,
  headers: {
    "X-Language": localStorage.getItem("lang") && localStorage.getItem("lang"),
    Authorization: `Bearer ${localStorage.getItem("id_token")}`,
  },
});

export default instance;
